'use client'

import UIButton from '@components/ui/UIButton'
import { UIButtonState } from '@components/ui/UIButton/UIButtonRoot'
import UIFlex from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import { Icon24Dislike } from 'src/assets/icons/Icon24Dislike'
import { Icon24Like } from 'src/assets/icons/Icon24Like'

interface RecommendButtonProps extends UIButtonState {
	buttonType: 'like' | 'dislike'
	isPressed?: boolean
	count?: number
}
const RecommendButton = ({ buttonType, isPressed, count, ...props }: RecommendButtonProps) => {
	return (
		<UIButton
			variant="outlined"
			size="lg"
			color="neutral"
			sx={{
				'&.MuiButton-root': {
					padding: `${pxToRem(9)} ${pxToRem(17)} ${pxToRem(9)} ${pxToRem(15)}`,
					minWidth: `${pxToRem(119)}`,
					height: `${pxToRem(44)}`,
					borderRadius: pxToRem(4),
				},
			}}
			{...props}
		>
			{buttonType === 'like' ? (
				<Icon24Like isLiked={isPressed} />
			) : (
				<Icon24Dislike isDisliked={isPressed} />
			)}
			<UIFlex
				flexDirection="row"
				component={UIText}
				fontSize={pxToRem(16)}
				lineHeight={pxToRem(24)}
				fontWeight={600}
				sx={{ '&> *:not(:first-child)': { marginLeft: pxToRem(4) } }}
			>
				<UIText color={isPressed ? color.colPointBlue : color.colBlack}>
					{buttonType === 'like' ? '좋아요' : '싫어요'}
				</UIText>
				<UIText fontWeight={700} color={isPressed ? color.colPointBlue : color.colBlack}>
					{count ? count.toLocaleString('ko-KR') : 0}
				</UIText>
			</UIFlex>
		</UIButton>
	)
}

export default RecommendButton
